module.exports = __webpack_public_path__ + "static/media/viber.ee9aa08e.svg";